import { createRouter, createWebHistory, type Router } from 'vue-router'
import type { BuildMode } from '@/shared/types/BuildMode'

export enum RouterPaths {
  STATUS = `/status`,
  STEPS = `/steps`,
  CHAT = `/chat`,
  MAP = `/map`
}
type RouterType = (p: { buildMode: BuildMode; params: object }) => Router

const router: RouterType = (props) => {
  return createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
      {
        path: RouterPaths.STATUS,
        name: 'status',
        component: () => import('./StatusModule.vue'),
        props
      },
      {
        path: RouterPaths.STEPS,
        name: 'steps',
        component: () => import('./StepsModule.vue'),
        props
      },
      {
        path: RouterPaths.CHAT,
        name: 'chat',
        component: () => import('./ChatModule.vue'),
        props
      },
      {
        path: RouterPaths.MAP,
        name: 'map',
        component: () => import('./MapModule.vue'),
        props
      }
    ]
  })
}

export default router
